import { useOverlayState } from "@heroui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@/src/common/components/ui";
import { buildCommunityUrl } from "@/src/common/lib/subdomain";

interface WelcomeJoinModalProps {
	isOpen: boolean;
	firstName: string;
	communitySlug: string;
}

export function WelcomeJoinModal({ isOpen, firstName, communitySlug }: WelcomeJoinModalProps) {
	const { t } = useTranslation("onboarding");
	const [seconds, setSeconds] = useState(5);

	const state = useOverlayState({ isOpen, onOpenChange: () => {} });

	useEffect(() => {
		if (!isOpen) return;

		const interval = setInterval(() => {
			setSeconds((prev) => {
				if (prev <= 1) {
					clearInterval(interval);
					window.location.href = buildCommunityUrl(communitySlug);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [isOpen, communitySlug]);

	return (
		<Modal state={state}>
			<Modal.Backdrop isDismissable={false}>
				<Modal.Container>
					<Modal.Dialog>
						<Modal.Body className="text-center py-8">
							<h2 className="text-xl font-bold mb-2">{t("join_welcome_title", { firstName })}</h2>
							<p className="text-sm text-foreground/40">{t("join_welcome_subtitle", { seconds })}</p>
						</Modal.Body>
					</Modal.Dialog>
				</Modal.Container>
			</Modal.Backdrop>
		</Modal>
	);
}
